<template>
  <div class="content-wrapper">
    <vs-row class="my-4">
      <vs-col vs-lg="8" vs-sm="12">
        <b-form-select
          style="display:inline-block; width:200px;"
          v-model="selectedDate"
          :options="dateList"
          class="mt-1 pr-3"
        />

        <b-form-select
          style="display:inline-block; width:200px;"
          v-model="selectedVenue"
          :options="venueList"
          class="mt-1"
        />
      </vs-col>
      <vs-col vs-align="flex-end" vs-lg="4" vs-sm="12">
        <div style="float: right" class="ml-2 pt-2">
          <i
            class="fas fa-file-download fa-2x cursor-pointer hover:text-primary"
            @click="onExport()"
          ></i>
        </div>
        <div style="float: right">
          <!--
          <vs-input
            id="search"
            class="inputx"
            placeholder="Search..."
            v-model="search"
            v-on:input="debounceInput"
          />
          -->
        </div>
      </vs-col>
    </vs-row>
    <vx-card>
      <b-table
        ref="table"
        style="min-height: 600px"
        striped
        hover
        fixed
        responsive
        show-empty
        sort-icon-left
        :selectable="true"
        :select-mode="`multi`"
        :busy.sync="isBusy"
        :items="selectedList"
        :fields="columns"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :filterIncludedFields="filterOn"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
      >
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2" style="height: 600px">
            <b-spinner class="align-middle"></b-spinner>
            <div class="mt-3">
              <strong>Loading...</strong>
            </div>
          </div>
        </template>
        <template v-slot:cell(pro_name)="data">
          <div style="width: 200px">
            <strong>{{ data.item.pro_name }}</strong>
            <a :href="data.item.url" target="_blank">
              <feather-icon
                icon="ExternalLinkIcon"
                svgClasses="h-4 w-4"
                class="cursor-pointer p-2"
              ></feather-icon>
            </a>
            <!--
            <feather-icon
              icon="ExternalLinkIcon"
              class="ml-2"
              style="width: 12px"
              @click="openExternalUrl(data.item)"
            />
            -->
          </div>
        </template>

        <template v-slot:cell(live_status)="data">
          <div style="width: 200px">
            {{ data.item.live_status }}
            <vs-button
              v-if="data.item.live_status != null"
              color="primary"
              size="small"
              type="flat"
              @click="onLiveStatusChanged(data.item)"
              >Change</vs-button
            >
            <!--
            <select
              v-model="data.item.live_status"
              class="form-control"
              @change="onLiveStatusChanged(data.item)"
            >
              <option value="startsoon">Start Soon</option>
              <option value="delayed">Delayed</option>
              <option value="started">Started</option>
              <option value="ended">Ended</option>
            </select>
            -->
          </div>
        </template>

        <template v-slot:cell(datetime)="data">
          <div style="width: 200px">
            <strong>{{ data.item.datetime }}</strong>
          </div>
        </template>

        <template v-slot:cell(creator_endpoint_url)="data">
          <vs-input
            size="small"
            placeholder="Creator URL"
            v-model="data.item.creator_endpoint_url"
            readonly
            @click="doCopy(data.item.creator_endpoint_url)"
          />
        </template>
        <template v-slot:cell(creator_stream_key)="data">
          <vs-input
            size="small"
            placeholder="Stream Key"
            v-model="data.item.creator_stream_key"
            readonly
            @click="doCopy(data.item.creator_stream_key)"
          />
        </template>

        <template v-slot:cell(speaker_url)="data">
          <div style="width: 100px">
            <a
              v-if="e == 'community2020'"
              :href="data.item.speaker_url"
              target="_blank"
            >
              <feather-icon
                icon="ExternalLinkIcon"
                svgClasses="h-4 w-4"
                class="cursor-pointer p-2"
              ></feather-icon>
            </a>
          </div>
        </template>

        <template v-slot:cell(viewer_endpoint_url)="data">
          <vs-input
            size="small"
            placeholder="Viewer URL"
            v-model="data.item.viewer_endpoint_url"
            readonly
            @click="doCopy(data.item.viewer_endpoint_url)"
          />
        </template>

        <!--
        <template v-slot:cell(action)="data">
          <vs-button @click="open(data.item)" color="primary" type="flat"
            >View</vs-button
          >
        </template>
          -->
      </b-table>
    </vx-card>

    <b-modal
      hide-footer
      style="z-index: 99999"
      id="status-modal"
      size="sm"
      :title="`Live Status`"
    >
      <ul class="leftx">
        <!--
        <li>
          <vs-radio
            v-model="selectedLiveStatus"
            vs-name="radios1"
            vs-value="startsoon"
            >Start Soon</vs-radio
          >
        </li>
        <li>
          <vs-radio
            v-model="selectedLiveStatus"
            vs-name="radios1"
            vs-value="delayed"
            >Delayed</vs-radio
          >
        </li>
        -->
        <li>
          <vs-radio
            v-model="selectedLiveStatus"
            vs-name="radios1"
            vs-value="started"
            >Started</vs-radio
          >
        </li>
        <li>
          <vs-radio
            v-model="selectedLiveStatus"
            vs-name="radios1"
            vs-value="ended"
            >Ended</vs-radio
          >
        </li>
      </ul>
      <div class="mt-5 text-center">
        <vs-button @click="onStatusSubmit"> Confirm </vs-button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Service from "@/services";
import XLSX from "xlsx"; // import xlsx
import moment from "moment";

export default {
  components: {},
  data: () => ({
    suffixParams: "",
    selectedEventId: null,
    selectedLiveStatus: null,
    selectedDate: 0,
    selectedDateVal: 0,
    selectedVenue: null,
    results: [],
    selectedList: [],
    dateList: [],
    columns: [
      { label: "ID", key: "event_id", sortable: false },
      {
        label: "Session Name",
        key: "pro_name",
        sortable: false,
        tdClass: "width-450"
      },
      {
        label: "Status",
        key: "live_status",
        sortable: false,
        tdClass: "width-450"
      },
      {
        label: "Start Date",
        key: "datetime",
        tdClass: "width-100",
        sortable: false
      },
      {
        label: "Stage",
        key: "venue",
        tdClass: "width-100",
        sortable: false
      },
      {
        label: "Engine",
        key: "live_engine",
        tdClass: "width-300",
        sortable: false
      },
      {
        label: "Speaker URL",
        key: "speaker_url",
        tdClass: "width-300",
        sortable: false
      },
      {
        label: "Creator URL",
        key: "creator_endpoint_url",
        sortable: false
      },
      {
        label: "Creator Secret Key",
        key: "creator_stream_key",
        sortable: false
      },
      {
        label: "Viewer URL",
        key: "viewer_endpoint_url",
        sortable: false
      },
      { label: "", key: "action", tdClass: "width-300", sortable: false }
    ],
    search: "",
    filter: "",
    sortBy: "",
    sortDesc: false,
    sortDirection: "asc",
    from: 1,
    to: 0,
    isBusy: false,
    currentPage: 1,
    perPage: 500,
    totalRows: 0,
    selected: [],
    filterOn: [],
    venueList: [],
    pageOptions: [2, 5, 10, 15, 30, 50],
    statusOrder: ["started", "startsoon", "ended"]
  }),
  mounted() {
    this.suffixParams =
      "?s=" + this.$route.query.s + "&e=" + this.$route.query.e;

    this.init();
  },
  computed: {
    ...mapState({
      s: state => {
        return state.Utility.s;
      },
      e: state => {
        return state.Utility.e;
      }
    })
  },
  watch: {
    selectedDate(val) {
      this.selectedList = this.results[val].items;
      this.selectedDateVal = val;
    },
    selectedVenue(val) {
      this.selectedList = this.results[this.selectedDateVal].items.filter(
        x => x.venue == val
      );
    }
  },
  methods: {
    debounceInput: _.debounce(function(e) {
      this.filter = e;
      this.search = e;
    }, 500),
    init() {
      setTimeout(() => {
        this.isBusy = true;

        let data = {
          e: this.$route.query.e,
          s: this.$route.query.s,
          perPage: 500,
          per_page: 500,
          currenPage: 1
        };

        let params = Object.keys(data)
          .map(key => key + "=" + data[key])
          .join("&");

        Service.Session.getLives(params)
          .then(res => {
            this.isBusy = false;

            let rows = res.data.rows.map(item => {
              let speaker_url =
                "https://book.apcom.org/" + item.slug + "/speaker";
              return {
                event_id: item.event_id,
                pro_name: item.pro_name,
                datetime: moment(item.datetime, "YYYY-MM-DD HH:mm").format(
                  "DD MMM YYYY | HH:mm"
                ),
                datetime_ref: item.datetime,
                venue: item.venue,
                url: item.url,
                live_status: item.live_status,
                live_engine: item.live ? item.live.live_engine : null,
                creator_endpoint_url: item.live
                  ? item.live.creator_endpoint_url
                  : null,
                creator_stream_key: item.live
                  ? item.live.creator_stream_key
                  : null,
                viewer_endpoint_url: item.live
                  ? item.live.viewer_endpoint_url
                  : null,
                speaker_url: speaker_url
              };
            });

            let groups = rows.reduce(function(obj, item) {
              obj[moment(item.datetime_ref).format("DD MMM")] =
                obj[moment(item.datetime_ref).format("DD MMM")] || [];
              obj[moment(item.datetime_ref).format("DD MMM")].push({
                ...item
              });
              return obj;
            }, {});

            let groupsVenue = rows.reduce(function(obj, item) {
              obj[item.venue] = obj[item.venue] || [];
              obj[item.venue].push({
                ...item
              });
              return obj;
            }, {});

            Object.keys(groupsVenue).map(key => {
              this.venueList.push({ text: key, value: key });
            });

            var myArray = Object;
            myArray = Object.keys(groups).map(key => {
              let session = groups[key];
              session.sort(this.compareValues("datetime_ref", "asc"));
              return {
                title: key,
                datetime: key,
                selected: false,
                items: session
              };
            });

            myArray.sort(this.compareValues("datetime_ref", "asc"));

            this.results = myArray;

            this.dateList = this.results.map(item => {
              return { text: item.title, value: item.datetime };
            });
            this.results.map(item => {
              item.items.sort(
                (a, b) =>
                  this.statusOrder.indexOf(a.live_status) -
                  this.statusOrder.indexOf(b.live_status)
              );
            });
            this.selectedList = this.results[0].items;
          })
          .catch(error => {
            // Here we could override the busy state, setting isBusy to false
            // this.isBusy = false
            // Returning an empty array, allows table to correctly handle
            // internal busy state in case of error
            //return [];
            // callback([]);
          });
        return null;
      }, 1500);
    },
    compareValues(key, order = "asc") {
      return function(a, b) {
        if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
          return 0;
        }

        const varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
        const varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

        let comparison = 0;
        if (varA > varB) {
          comparison = 1;
        } else if (varA < varB) {
          comparison = -1;
        }
        return order == "desc" ? comparison * -1 : comparison;
      };
    },
    open(item) {
      this.$router.push(
        "/conferences/sessions/" + item.slug + "/view" + "" + this.suffixParams
      );
    },
    onLiveStatusChanged(item) {
      let a = Object.assign({}, item);
      this.selectedEventId = a.event_id;
      this.selectedLiveStatus = a.live_status;
      this.$bvModal.show("status-modal");
    },
    onStatusSubmit() {
      this.$vs.loading();
      Service.Session.updaveLiveStatus({
        e: this.e,
        s: this.s,
        event_id: this.selectedEventId,
        live_status: this.selectedLiveStatus
      }).then(res => {
        this.$vs.loading.close();
        this.$bvModal.hide("status-modal");
        this.$refs.table.refresh();
      });
    },
    onExport() {
      let rows = [];
      let days = [];

      let header = this.columns.map((item, index) => {
        return { text: item.label };
      });

      this.$vs.loading();
      let data = {
        e: this.$route.query.e,
        s: this.$route.query.s,
        perPage: 200,
        currentPage: 1
      };

      let params = Object.keys(data)
        .map(key => key + "=" + data[key])
        .join("&");

      Service.Session.getLives(params).then(res => {
        rows = res.data.rows.map((item, index) => {
          return {
            event_id: item.event_id,
            pro_title: item.pro_title,
            date: item.date,
            time: item.time,
            live_engine: item.live[0].live_engine,
            creator_endpoint_url: item.live[0].creator_endpoint_url,
            creator_stream_key: item.live[0].creator_stream_key,
            viewer_endpoint_url: item.live[0].viewer_endpoint_url
          };
        });
        let dataExport = {};
        const dataWS = XLSX.utils.json_to_sheet(rows);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, dataWS);
        XLSX.writeFile(wb, "live_videos_list.xlsx");
        this.$vs.loading.close();
      });
    },
    doCopy(text) {
      this.$copyText(text).then(
        e => {
          this.$vs.notify({
            title: "Success",
            text: "Copied",
            color: "success"
          });
        },
        e => {
          this.$vs.notify({
            title: "Oops!",
            text: "Can not copy",
            color: "danger"
          });
        }
      );
    },
    openExternalUrl(item) {
      let url = "https://tech/";
      window.open(url, "_blank");
    }
  }
};
</script>

<style>
.width-250 {
  width: 250px;
}
.width-300 {
  width: 300px;
}
.width-450 {
  width: 450px;
}
</style>
